import styles from "../assets/styles/welcomeSubscription.module.scss";
import welcomeSubscriptionText from "../assets/images/welcome_subscription_text.png";
import welcomeSubscriptionKV from "../assets/images/welcome_subscription_kv.png";
import HeadBlock from "../components/HeadBlock";
import { Button } from "../components/Button";
import { useNavigate } from "react-router-dom";
// import { useAuthContext } from "../components/AuthContext";

export const WelcomeSubscription = () => {
  const navigate = useNavigate();
  // const { user, isSubscribed } = useAuthContext();

  // if (!user && !isSubscribed) {
  //   navigate("/subscription");
  // }

  const handleClick = () => {
    navigate("/my-contents");
  };

  return (
    <>
      <HeadBlock title="聴き放題プランへようこそ" />
      <div className={styles.container}>
        <img
          className={styles.welcomeSubscriptionText}
          src={welcomeSubscriptionText}
          alt=""
        />
        <img
          className={styles.welcomeSubscriptionKV}
          src={welcomeSubscriptionKV}
          alt=""
        />
        <Button onClick={handleClick}>さっそく聴いてみる</Button>
      </div>
    </>
  );
};
